"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Layer = _interopRequireDefault(require("./Layer"));

var strings = _interopRequireWildcard(require("../../../../../utils/strings"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/* eslint-disable spaced-comment */
/// <reference path="../../../../../../node_modules/@types/openlayers/index.d.ts" />

/* eslint-enable spaced-comment */


var OpenLayersPolylineLayer =
/** @class */
function (_super) {
  __extends(OpenLayersPolylineLayer, _super);

  function OpenLayersPolylineLayer(layer, points, opts) {
    if (opts === void 0) {
      opts = undefined;
    }

    var _this = _super.call(this, layer, opts.id) || this;

    _this._opts = {};
    _this._points = points; // convert camelcase style keys to hypenated strings

    opts = opts || {};
    Object.keys(opts).forEach(function (key) {
      var k = strings.hyphenate(key);

      if (k !== key) {
        opts[k] = opts[key];
        delete opts[key];
      }
    });
    _this._opts = opts;
    return _this;
  }

  OpenLayersPolylineLayer.prototype.addTo = function (map, index) {
    _super.prototype.addTo.call(this, map, index);

    if (!this.layer) {
      this.invalidate();
    }
  };

  OpenLayersPolylineLayer.prototype.invalidate = function () {
    this.source = new ol.source.Vector(); // points.push(ol.proj.transform([xx,yy],'EPSG:4326', 'EPSG:3857'));

    var points = this._points.map(function (point) {
      return ol.proj.transform([point.lon, point.lat], 'EPSG:4326', 'EPSG:3857');
    });

    var feature = new ol.Feature({
      properties: {
        id: this.id
      },
      geometry: new ol.geom.LineString(points)
    });
    this.source.addFeature(feature);
    var stroke = this._opts.stroke;
    this.layer = new ol.layer.Vector({
      source: this.source,
      style: new ol.style.Style({
        stroke: stroke ? new ol.style.Stroke(stroke) : null
      })
    });

    if (this.map) {
      var map = this.map;
      this.remove();
      this.addTo(map, this._targetIndex);
    }
  };

  return OpenLayersPolylineLayer;
}(_Layer.default);

var _default = OpenLayersPolylineLayer;
exports.default = _default;
module.exports = exports.default;